import logger from "../../lib/appfuse-react/core/logger";
import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";


const LOGGER = logger.getLogger('inboxReducer');

const name = 'inbox';

const initialState = {
    data: [],
    selection: null,
    pageNumber: 0,
    pageSize: 10,
    criteria: {},
    sort: null,
    drafts: {},
    nodeId: null,
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setData(state, action) {
            state.data = json.toJSON(action.payload);
        },
        setSelection(state, action) {
            state.selection = json.toJSON(action.payload);
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageSize(state, action) {
            state.pageSize = action.payload;
        },
        setCriteria(state, action) {
            state.criteria = json.toJSON(action.payload);
        },
        setSort(state, action) {
            state.sort = json.toJSON(action.payload);
        },
        setDrafts(state, action) {
            state.drafts = json.toJSON(action.payload);
        },
        setNodeId(state, action) {
            state.nodeId = action.payload;
        },

    }
});

export const {setData, setSelection, setPageNumber, setPageSize, setCriteria, setDrafts, setSort, setNodeId} = slice.actions;
const {reducer} = slice;

export const selectData = state => json.fromJSON(state[name].data);
export const selectCriteria = state => state[name].criteria;
export const selectSort = state => json.fromJSON(state[name].sort);
export const selectSelection = state => json.fromJSON(state[name].selection);
export const selectPageNumber = state => state[name].pageNumber;
export const selectPageSize = state => state[name].pageSize;
export const selectNodeId = state => state[name].nodeId;
export const selectDrafts = state => json.fromJSON(state[name].drafts);
export const selectDraft = (key) => (state) => selectDrafts(state)[key];


export const setDraft = (key, draft) => (dispatch, getState) => {
    const drafts = selectDrafts(getState());
    drafts[key] = draft;
    dispatch(setDrafts(drafts));
}

export const removeDraft = key => (dispatch, getState) => {
    const drafts = selectDrafts(getState());
    delete drafts[key];
    dispatch(setDrafts(drafts));
}

const inboxReducer = reducer;
export default inboxReducer;